import Card from "../../components/Card";
import { Toolbar } from "../../ui-components";
import ForAssignManager from "./ForAssignManager";
import AssignManager from "./AssignManager";
import DiscardedManager from "./DiscardedManager";
import UpdateLeadForm from "../../generalComponents/UpdateLeadForm";
import Filters from "../../generalComponents/Filters";
import DetailLead from "../../generalComponents/DetailLead";
import FollowManager from "./FollowManager";
import LeadsContext from "../../context/leads";
import { useContext, useEffect, useState } from "react";

const Manager = ({user, userName, idBranch}) => {
  const {obtainCollaborators, collaboratorID} = useContext(LeadsContext);
  const [option, setOption] = useState(1);
  const [assingLead, setAssignLead] = useState();
  const [order, setOrder] = useState("1")
  const [canal, setCanal] = useState("0")
  const [asesor, setAsesor] = useState("0")

  const idSucursal = parseInt(idBranch)
  
  const toggleTab = (index) => {
    setOption(index);
  };

  const overridesToolbar = {
    ButtonUno: {
      backgroundColor: option === 1 && "#323977",
      onClick: () => toggleTab(1),
    },
    ButtonDos: {
      backgroundColor: option === 2 && "#323977",
      onClick: () => toggleTab(2),
    },
    ButtonTres: {
      backgroundColor: option === 3 && "#323977",
      onClick: () => toggleTab(3),
    },
    ButtonCuatro: {
        backgroundColor: option === 4 && "#323977",
        onClick: () => toggleTab(4),
    },
  };

  useEffect(() => {
    obtainCollaborators(idSucursal);
  }, [idBranch, collaboratorID]);

  console.log(idSucursal)

  return (
    <div className="mt-16">
     {option < 5 && 
      (<Card
        textTitle="Leads - Gerencia" 
        elementBody={
          <div className="flex flex-col gap-6 px-6">
            <div className="flex justify-center">
              <Toolbar type={"leadmanager"} width={"100%"} overrides={overridesToolbar}/>
            </div>
            <div>
              <Filters setorder={setOrder} order={order} canal={canal} setCanal={setCanal} asesor={asesor} setAsesor={setAsesor} user={user}/>
            </div>
            {option === 1 && (<div><ForAssignManager setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} idBranch={idSucursal} canal={canal} asesor={asesor}/> </div>)}
            {option === 2 && (<div><AssignManager setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} idBranch={idSucursal} canal={canal} asesor={asesor}/> </div>)}
            {option === 3 && (<div><DiscardedManager setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} idBranch={idSucursal} canal={canal} asesor={asesor}/></div>)}
            {option === 4 && (<div><FollowManager setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} idBranch={idSucursal} canal={canal} asesor={asesor}/></div>)}
          </div>
        }
      />)  
    } 
      {option === 5 && <UpdateLeadForm assingLead={assingLead}  onToggleTab={toggleTab} user={user} userName={userName}/> }
      {option === 6 && <DetailLead assingLead={assingLead} onToggleTab={toggleTab}/>}
    </div>
  );
};

export default Manager;
